import { useCallback, useMemo } from 'react';
import { getPotsStatement, getCapitalGainsAndIncome, } from 'features/invest/actions';
import links from 'utils/links';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useFetchOld, { muteErrorAndResultButThrows } from 'hooks/useFetch';
import { isAndroid } from '../../../constants';
const getInfo = (type) => {
    switch (type) {
        case 'CapitalGainsAndIncome':
            return {
                apiFn: getCapitalGainsAndIncome,
                fileName: 'Emma_trading_activity_statement',
            };
        case 'Pots':
            return {
                apiFn: getPotsStatement,
                fileName: 'Emma_interest_statement',
            };
        default:
            return undefined;
    }
};
export const useGenerateStatements = (type) => {
    const navigation = useMainStackNavigation();
    const [, , isFetching, fetch] = useFetchOld(muteErrorAndResultButThrows);
    const info = useMemo(() => getInfo(type), [type]);
    const generateStatements = useCallback(async (from, to) => {
        if (!info)
            return;
        try {
            const response = await fetch(info.apiFn(from, to));
            const url = response?.url;
            if (url) {
                if (isAndroid) {
                    navigation.navigateDeprecated('Pdf', {
                        url,
                        fileName: `${info.fileName}_${from}to${to}`,
                    });
                }
                else {
                    links.openLink(url);
                }
            }
        }
        catch {
            //
        }
    }, [info]);
    return { isFetching, generateStatements };
};
